// UUID v4 generator with fallback for non-secure contexts
export default function uuid(): `${string}-${string}-${string}-${string}-${string}` {
	const g: any = globalThis as any;
	try {
		if (g.crypto && typeof g.crypto.randomUUID === 'function') {
			return g.crypto.randomUUID();
		}
	} catch {
		// ignore and fallback
	}
	// Fallback to Math.random-based v4 UUID
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		const r = Math.floor(Math.random() * 16);
		const v = c === 'x' ? r : (r & 0x3) | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
		return v.toString(16);
	}) as `${string}-${string}-${string}-${string}-${string}`;
}
